import { useTranslation } from '../../../hooks/useNavConfig';
export let LinkBadgeType;
(function (LinkBadgeType) {
  LinkBadgeType["comingSoon"] = "COMING_SOON";
  LinkBadgeType["beta"] = "BETA";
  LinkBadgeType["new"] = "NEW";
  LinkBadgeType["upgradeArrow"] = "UPGRADE_ARROW";
  LinkBadgeType["trial"] = "TRIAL";
})(LinkBadgeType || (LinkBadgeType = {}));
export const useLinkBadgeData = ({
  id,
  navItems
}) => {
  const {
    t
  } = useTranslation();
  const {
    lockedTooltip,
    isBeta,
    isComingSoon,
    isMarketing,
    isNew,
    isOps,
    isSales,
    isService,
    isLocked
  } = navItems.byId[id];
  const showUpgradeArrow = isSales || isService || isMarketing || isOps || isLocked;
  if (isComingSoon) {
    return {
      type: LinkBadgeType.comingSoon,
      text: t('nav.badges.comingSoon')
    };
  }
  if (isBeta) {
    return {
      type: LinkBadgeType.beta,
      text: t('nav.badges.beta')
    };
  }
  if (isNew) {
    return {
      type: LinkBadgeType.new,
      text: t('nav.badges.new')
    };
  }
  if (showUpgradeArrow) {
    return {
      type: LinkBadgeType.upgradeArrow,
      tooltipText: lockedTooltip
    };
  }
  return undefined;
};